<script setup lang="ts">
import { Login } from '@/components';
</script>

<template>
    <div class="login-container">
        <Login />
    </div>
</template>

<style scoped lang="scss">
.login-container {
    height: 100vh;
    background-color: #f5f7fa;
}
</style>
